import { render, staticRenderFns } from "./SAASTable.vue?vue&type=template&id=3260358f"
import script from "./SAASTable.vue?vue&type=script&lang=js"
export * from "./SAASTable.vue?vue&type=script&lang=js"
import style0 from "./SAASTable.vue?vue&type=style&index=0&id=3260358f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports